import { createRoot } from "react-dom/client";

import App from "./App";
import { OpenAPI } from "./api/SolarCloudApi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./i18n";
import { apiServer } from "./util/apiServer";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import TagManager from 'react-gtm-module';

import EnvironmentContextProvider from "./contexts/EnvironmentContext";

// logger.log("@@@@ apiServer", apiServer);

TagManager.initialize({ gtmId: 'GTM-WLG4267J' });

export const queryClient = new QueryClient();

OpenAPI.BASE = apiServer ?? "";

const container = document.getElementById("root");

const root = createRoot(container!);
root.render(
  <QueryClientProvider client={queryClient}>
    <EnvironmentContextProvider>
      <App />
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </EnvironmentContextProvider>
  </QueryClientProvider>
);
